import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  addInitialcart,
  addSelectedBook,
  addTocart,
  addTofavorite,
  deleteItem,
  deletefavorite,
  resetCart,
  resetfavorite,
  removeUser,
} from "../redux/productSlice";
import axios from "axios";
import bookPlaceHolder from "../../assets/bookPlaceHolder.png";
import { useNavigate } from "react-router-dom";

const AuthContext = React.createContext({
  selectedcurrency: {},
  setselectedcurrency: () => {},
  isPopupCartOpen: {},
  setisPopupCartOpen: () => {},
  addedBookCart: {},
  setaddedBookCart: () => {},
  currencyRate: {},
  setcurrencyRate: () => {},
  selectedlanguage: {},
  setselectedlanguage: () => {},
  isLoading: {},
  reviewData: {},
  setReviewData: () => {},
  bookDetails: {},
  setbookDetails: () => {},
  returnData: {},
  setReturnData: () => {},
  editreturnData: {},
  seteditReturnData: () => {},
  addToCart: () => {},
  addToCartWithQty: () => {},
  deleteFromcart: () => {},
  addToFavorite: () => {},
  deleteFavorite: () => {},
  articles: [],
  categories: [],
  setArticles: () => {},
  fetchArticles: () => {},
  fetchCategories: () => {},
  companySettings: [],
  setCompanySettings: () => {},
  fetchCompanySettings: () => {},
  collections: [],
  setCollections: () => {},
  fetchCollections: () => {},
  collaborators: [],
  setCollaborators: () => {},
  fetchCollaborators: () => {},
  fetchfavandcartSettings: () => {},

  countries: [],
  setCountries: () => {},

  societeConfig: [],
  setSocieteConfig: () => {},

  isCompareEnabled: [],
  setIsCompareEnabled: () => {},

  checkoutError: {},
  setCheckoutError: () => {},

  publishers: [],
  setPublishers: () => {},
});

export const AuthContextProvider = (props) => {
  const [selectedcurrency, setselectedcurrency] = useState("eur");
  const [isPopupCartOpen, setisPopupCartOpen] = useState(false);
  const [addedBookCart, setaddedBookCart] = useState({});
  const [currencyRate, setcurrencyRate] = useState(null);
  const [selectedlanguage, setselectedlanguage] = useState("fr");
  const [reviewData, setReviewData] = useState([]);
  const [bookDetails, setbookDetails] = useState({});
  const [returnData, setReturnData] = useState([]);
  const [editreturnData, seteditReturnData] = useState({});
  const [articles, setArticles] = useState([]);
  const [companySettings, setCompanySettings] = useState([]);
  const [categories, setCategories] = useState([]);
  const [collaborators, setCollaborators] = useState([]);
  const [collections, setCollections] = useState([]);
  const [societeConfig, setSocieteConfig] = useState([]);
  const [countries, setCountries] = useState([]);
  const [checkoutError, setCheckoutError] = useState(null);
  const [publishers, setPublishers] = useState([]);
  const dispatch = useDispatch();
  const productData = useSelector((state) => state.products.productData);
  const favorites = useSelector((state) => state.products.favorites);
  const user = useSelector((state) => state.products.userInfo);
  const language = useSelector(
    (state) => state.products.selectedLanguage[0].Language
  );
  const [isLoading, setIsLoading] = useState(false);
  const [isCompareEnabled, setIsCompareEnabled] = useState(true);

  const token = localStorage.getItem("token");

  const setReviewDatahandler = (reviewData) => {
    setReviewData(reviewData);
  };

  const setBookDetailshandler = (reviewData) => {
    setbookDetails(reviewData);
    dispatch(addSelectedBook(reviewData));
  };

  const addToCarthandler = async ({ props }) => {
    if (!user?.id) {
      console.log(props);
      dispatch(
        addTocart({
          _id: props.id,
          title: props.designation,
          author: props.dc_auteur,
          image: props.articleimage[0]?.link
            ? props.articleimage[0].link
            : bookPlaceHolder,
          price: props.prixpublic,
          _qte_a_terme_calcule: props._qte_a_terme_calcule,
          _code_barre: props._code_barre,
          quantity: 1,
          discount: props.discount,
          description: props.descriptif,
          weight: props._poids_net,
          average_rate: props.average_rate,
          price_ttc: props._prix_public_ttc,
          article_stock: props.article_stock,
        })
      );

      toast.success(
        `${
          language === "eng"
            ? "Book is added to Cart"
            : "Le livre est ajouté au panier"
        }`,
        {
          position: "top-right",
          autoClose: 1500,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
          theme: "colored",
        }
      );
    } else {
      const item = productData.find((item) => item._id === props.id);
      if (!item) {
        try {
          setIsLoading(true);
          const response = await axios.post(
            `${process.env.REACT_APP_TESTING_API}/cart?ecom_type=${process.env.REACT_APP_ECOM_TYPE}`,
            {
              user_id: user.id,
              article_id: props.id,
              quantity: 1,
            }
          );
          dispatch(
            addTocart({
              _id: props.id,
              title: props.designation,
              author: props.dc_auteur,
              image: props.articleimage[0]?.link
                ? props.articleimage[0].link
                : bookPlaceHolder,
              price: props.prixpublic,
              _qte_a_terme_calcule: props._qte_a_terme_calcule,
              _code_barre: props._code_barre,
              quantity: 1,
              discount: props.discount,
              description: props.descriptif,
              cart_id: response.data.data.id,
              weight: props._poids_net,
              average_rate: props.average_rate,
              price_ttc: props._prix_public_ttc,
              article_stock: props.article_stock,
            })
          );

          toast.success(
            `${
              language === "eng"
                ? "Book is added to Cart"
                : "Le livre est ajouté au panier"
            }`,
            {
              position: "top-right",
              autoClose: 1500,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: 0,
              theme: "colored",
            }
          );
        } catch (error) {
          console.error("Error adding to cart:", error);
          toast.error(
            `${
              language === "eng"
                ? "Failed to add item to cart."
                : "Échec de l'ajout d'un article au panier."
            }`,
            {
              position: "top-right",
              autoClose: 1500,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: 0,
              theme: "colored",
            }
          );
        } finally {
          setIsLoading(false);
        }
      } else {
        const newQuantity = item.quantity + 1;
        if (newQuantity <= item._qte_a_terme_calcule) {
          setIsLoading(true);
          axios
            .put(`${process.env.REACT_APP_TESTING_API}/cart/${item.cart_id}`, {
              quantity: newQuantity,
            })
            .then((response) => {
              console.log("PUT request successful:", response.data);
              dispatch(
                addTocart({
                  _id: props.id,
                })
              );
              setIsLoading(false);
              toast.success(
                `${
                  language === "eng"
                    ? "Book is added to Cart"
                    : "Le livre est ajouté au panier"
                }`,
                {
                  position: "top-right",
                  autoClose: 1500,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: 0,
                  theme: "colored",
                }
              );
            })
            .catch((error) => {
              console.error("Error in PUT request:", error);
              setIsLoading(false);
              toast.error(
                `${
                  language === "eng"
                    ? "Failed to add item to cart."
                    : "Échec de l'ajout d'un article au panier."
                }`,
                {
                  position: "top-right",
                  autoClose: 1500,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: 0,
                  theme: "colored",
                }
              );
            });
        } else {
          toast.info(
            language === "eng"
              ? "No more items in stock"
              : "Plus d'articles en stock",
            {
              position: "top-right",
              autoClose: 1500,
              hideProgressBar: true,
              theme: "colored",
            }
          );
        }
      }
    }
  };

  const addToCartWithQtyhandler = async (props) => {
    const maxQuantity = props._qte_a_terme_calcule;
    const item = productData.find((item) => item._id === props.id);

    console.log(item);
    if (!user?.id) {
      const newQuantity =
        Number(item?.quantity * 1) + Number(props.quantity * 1);
      const newQuantityMax = Number(maxQuantity) - Number(item?.quantity * 1);
      if (Number(newQuantity) > Number(maxQuantity)) {
        dispatch(
          addTocart({
            _id: props.id,
            title: props.designation,
            author: props.dc_auteur,
            image: props.articleimage[0]?.link
              ? props.articleimage[0].link
              : bookPlaceHolder,
            price: props.prixpublic,
            _qte_a_terme_calcule: props._qte_a_terme_calcule,
            _code_barre: props._code_barre,
            quantity: Number(newQuantityMax).toFixed(0),
            discount: props.discount,
            description: props.descriptif,
            weight: props._poids_net,
            average_rate: props.average_rate,
            price_ttc: props._prix_public_ttc,
            article_stock: props.article_stock,
          })
        );
        setIsLoading(false);
        toast.success(
          `${
            language === "eng"
              ? "Book is added to Cart"
              : "Le livre est ajouté au panier"
          }`,
          {
            position: "top-right",
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
            theme: "colored",
          }
        );
      } else {
        dispatch(
          addTocart({
            _id: props.id,
            title: props.designation,
            author: props.dc_auteur,
            image: props.articleimage[0]?.link
              ? props.articleimage[0].link
              : bookPlaceHolder,
            price: props.prixpublic,
            _qte_a_terme_calcule: props._qte_a_terme_calcule,
            _code_barre: props._code_barre,
            quantity: props.quantity,
            discount: props.discount,
            description: props.descriptif,
            weight: props._poids_net,
            average_rate: props.average_rate,
            price_ttc: props._prix_public_ttc,
            article_stock: props.article_stock,
          })
        );
        setIsLoading(false);
        toast.success(
          `${
            language === "eng"
              ? "Book is added to Cart"
              : "Le livre est ajouté au panier"
          }`,
          {
            position: "top-right",
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
            theme: "colored",
          }
        );
      }
    } else {
      if (!item) {
        try {
          setIsLoading(true);
          const response = await axios.post(
            `${process.env.REACT_APP_TESTING_API}/cart?ecom_type=${process.env.REACT_APP_ECOM_TYPE}`,
            {
              user_id: user.id,
              article_id: props.id,
              quantity: props.quantity,
            }
          );
          dispatch(
            addTocart({
              _id: props.id,
              title: props.designation,
              author: props.dc_auteur,
              image: props.image,
              price: props.prixpublic,
              _qte_a_terme_calcule: props._qte_a_terme_calcule,
              discount: props.discount,
              quantity: props.quantity,
              description: props.descriptif,
              weight: props._poids_net,
              cart_id: response.data.data.id,
              average_rate: props.average_rate,
              price_ttc: props._prix_public_ttc,
              article_stock: props.article_stock,
            })
          );

          toast.success(
            `${
              language === "eng"
                ? "Book is added to Cart"
                : "Le livre est ajouté au panier"
            }`,
            {
              position: "top-right",
              autoClose: 1500,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: 0,
              theme: "colored",
            }
          );
        } catch (error) {
          // console.error("Error adding to cart:", error);
          toast.error(
            `${
              language === "eng"
                ? "Failed to add item to cart."
                : "Échec de l'ajout d'un article au panier."
            }`,
            {
              position: "top-right",
              autoClose: 1500,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: 0,
              theme: "colored",
            }
          );
          console.log(error);
        } finally {
          setIsLoading(false);
        }
      } else {
        const newQuantity =
          Number(item.quantity * 1) + Number(props.quantity * 1);
        const newQuantityMax = Number(maxQuantity) - Number(item.quantity * 1);
        // console.log("item.quantity", item.quantity)
        // console.log("props.quantity", props.quantity)
        // console.log("newQuantity", newQuantity)
        setIsLoading(true);
        if (Number(newQuantity) > Number(maxQuantity)) {
          axios
            .put(`${process.env.REACT_APP_TESTING_API}/cart/${item.cart_id}`, {
              quantity: Number(maxQuantity).toFixed(0),
            })
            .then((response) => {
              // console.log("PUT request successful:", response.data);
              dispatch(
                addTocart({
                  _id: props.id,
                  quantity: Number(newQuantityMax).toFixed(0),
                })
              );
              setIsLoading(false);
              toast.success(
                `${
                  language === "eng"
                    ? "Book is added to Cart"
                    : "Le livre est ajouté au panier"
                }`,
                {
                  position: "top-right",
                  autoClose: 1500,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: 0,
                  theme: "colored",
                }
              );
            })
            .catch((error) => {
              console.error("Error in PUT request:", error);
              setIsLoading(false);
              toast.error(
                `${
                  language === "eng"
                    ? "Failed to add item to cart."
                    : "Échec de l'ajout d'un article au panier."
                }`,
                {
                  position: "top-right",
                  autoClose: 1500,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: 0,
                  theme: "colored",
                }
              );
            });
        } else {
          axios
            .put(`${process.env.REACT_APP_TESTING_API}/cart/${item.cart_id}`, {
              quantity: newQuantity,
            })
            .then((response) => {
              // console.log("PUT request successful:", response.data);
              dispatch(
                addTocart({
                  _id: props.id,
                  quantity: props.quantity,
                })
              );
              setIsLoading(false);
              toast.success(
                `${
                  language === "eng"
                    ? "Book is added to Cart"
                    : "Le livre est ajouté au panier"
                }`,
                {
                  position: "top-right",
                  autoClose: 1500,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: 0,
                  theme: "colored",
                }
              );
            })
            .catch((error) => {
              // console.error("Error in PUT request:", error);
              setIsLoading(false);
              toast.error(
                `${
                  language === "eng"
                    ? "Failed to add item to cart."
                    : "Échec de l'ajout d'un article au panier."
                }`,
                {
                  position: "top-right",
                  autoClose: 1500,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: 0,
                  theme: "colored",
                }
              );
            });
        }
      }
    }
  };

  const deleteFromcarthandler = async (props) => {
    const item = productData.find((item) => item._id === props);
    if (user?.id) {
      axios
        .delete(`${process.env.REACT_APP_TESTING_API}/cart/${item.cart_id}`)
        .then(() => {
          // console.log("delete request successful:");
          dispatch(deleteItem(props));
          toast.success(
            `${language === "eng" ? "Book is removed" : "Le livre est retiré"}`,
            {
              position: "top-right",
              autoClose: 1500,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: 0,
              theme: "colored",
            }
          );
        })
        .catch((error) => {
          // console.error("Error in delete request:", error);
          toast.error(
            `${
              language === "eng"
                ? "Failed to delete item from cart."
                : "Échec de la suppression de l'article du panier."
            }`,
            {
              position: "top-right",
              autoClose: 1500,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: 0,
              theme: "colored",
            }
          );
        });
    } else {
      dispatch(deleteItem(props));
      toast.success(
        `${language === "eng" ? "Book is removed" : "Le livre est retiré"}`,
        {
          position: "top-right",
          autoClose: 1500,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
          theme: "colored",
        }
      );
    }
  };

  const fetchArticles = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_TESTING_API}/articles?ecom_type=${process.env.REACT_APP_ECOM_TYPE}`
      );

      setArticles(response.data.data);
    } catch (error) {
      // console.error('Error fetching articles:', error);
    }
  };

  const fetchCountries = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_TESTING_API}/countries?ecom_type=${process.env.REACT_APP_ECOM_TYPE}`
      );
      setCountries(response.data);
    } catch (error) {
      // console.error('Error fetching countries:', error);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_TESTING_API}/categories?ecom_type=${process.env.REACT_APP_ECOM_TYPE}`
      );
      const sorteddata = [...response.data]
        .filter((itt) => itt?._nom !== "")
        .sort((a, b) => a._nom.localeCompare(b._nom));
      setCategories(sorteddata);
    } catch (error) {
      // console.error('Error fetching categories:', error);
    }
  };

  const fetchCollaborators = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_TESTING_API}/collaborators?ecom_type=${process.env.REACT_APP_ECOM_TYPE}`
      );
      const sorteddata = [...response.data].sort((a, b) =>
        a._nom.localeCompare(b._nom)
      );
      setCollaborators(sorteddata);
    } catch (error) {
      // console.error('Error fetching collaborators:', error);
      // toast.error('Failed to fetch categories.');
    }
  };
  const fetchCollections = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_TESTING_API}/collections?ecom_type=${process.env.REACT_APP_ECOM_TYPE}`
      );
      const sorteddata = [...response.data].sort((a, b) =>
        a.nom.localeCompare(b.nom)
      );
      setCollections(sorteddata);
    } catch (error) {
      // console.error('Error fetching collections:', error);
    }
  };

  const fetchPublishers = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_TESTING_API}/publishers?ecom_type=${process.env.REACT_APP_ECOM_TYPE}`
      );
      const sorteddata = [...response.data].sort((a, b) =>
        a.title.localeCompare(b.title)
      );
      setPublishers(sorteddata);
    } catch (error) {
      // Handle error silently
    }
  };

  const fetchSocieteConfig = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_TESTING_API}/societe-config`
      );
      setSocieteConfig(response.data);
    } catch (error) {
      // console.error('Error fetching collections:', error);
    }
  };

  const fetchCompanySettings = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_TESTING_API}/company-settings?ecom_type=${process.env.REACT_APP_ECOM_TYPE}`
      );
      setCompanySettings(response.data.data);
      const compareSetting = response.data.data?.website_config?.find(
        (itt) => itt.lookup_config_type === 43
      )?.is_exist;
      setIsCompareEnabled(compareSetting);
      if (response.data.data?.usd_rate) {
        setcurrencyRate(response.data.data?.usd_rate);
      }
      localStorage.setItem("favIcon", response.data.data?.fav_icon);
    } catch (error) {
      // console.error('Error fetching articles:', error);
      // toast.error('Failed to fetch articles.');
    }
  };
  const fetchfavandcartSettings = async () => {
    if (user) {
      try {
        const cartResponse = await axios.get(
          `${process.env.REACT_APP_TESTING_API}/users/${user.id}/cart`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include token in the headers
            },
          }
        );
        const userCart = cartResponse.data.data;
        dispatch(resetCart());
        userCart.forEach((cartItem) => {
          const article_id = cartItem.article_id;
          const foundBook = articles.find((book) => book.id === article_id);
          dispatch(
            addInitialcart({
              cart_id: cartItem.id,
              _id: cartItem.article.id,
              title: cartItem.article.designation,
              author: cartItem.article.dc_auteur,
              image: cartItem.article.articleimage[0]?.link
                ? cartItem.article.articleimage[0].link
                : bookPlaceHolder,
              price: cartItem.article.prixpublic,
              _qte_a_terme_calcule: cartItem.article?._qte_a_terme_calcule,
              discount: cartItem.discount,
              _code_barre: cartItem.article._code_barre,
              quantity:
                cartItem.quantity < cartItem.article?._qte_a_terme_calcule
                  ? cartItem.quantity
                  : Number(cartItem.article?._qte_a_terme_calcule).toFixed(0),
              description: cartItem.article.descriptif,
              weight: cartItem.article._poids_net,
              price_ttc: cartItem.article._prix_public_ttc,
              removed: cartItem.removed,
              article_stock: cartItem.article.article_stock,
            })
          );
        });

        const favoriteResponse = await axios.get(
          `${process.env.REACT_APP_TESTING_API}/users/${user.id}/favorite`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include token in the headers
            },
          }
        );
        const favoriteCart = favoriteResponse.data.data; // Assuming cart data is returned in the response
        dispatch(resetfavorite());
        favoriteCart.forEach((favtItem) => {
          const article_id = favtItem.article_id;
          dispatch(
            addTofavorite({
              id: favtItem.id,
              _favid: favtItem.article.id,
              favtitle: favtItem.article.designation,
              favauthor: favtItem.article.dc_auteur,
              favimage: favtItem.article.articleimage[0]?.link
                ? favtItem.article.articleimage[0].link
                : bookPlaceHolder,
              favprice: favtItem.article.prixpublic,
              _qte_a_terme_calcule: favtItem.article?._qte_a_terme_calcule,
              favdescription: favtItem.article.descriptif,
              _code_barre: favtItem.article._code_barre,
              favquantity: 1,
              discount: favtItem.discount,
              weight: favtItem.article._poids_net,
              price_ttc: favtItem.article._prix_public_ttc,
              removed: favtItem.removed,
              article_stock: favtItem.article.article_stock,
            })
          );
        });
      } catch (error) {
        // const errormsg = error.response.data.error;
        // console.error('Error in Login:', `${errormsg}`);
      }
    }
  };

  const FetchUserData = async () => {
    await fetchfavandcartSettings();
  };

  const checkUserLoggedIn = async () => {
    // Only check if user exists and has an ID
    
    const sessionEndedMsg = language === "eng"
      ? "Session ended, please login again."
      : "Session terminée, veuillez vous reconnecter.";

    if (!user?.id) {
      dispatch(removeUser());
      localStorage.removeItem("token");
      return { is_logged_in: false };
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_TESTING_API}/is-user-logged-in`,
        { user_id: user.id }
      );

      // If response indicates user is not logged in, remove user from state
      if (!response.data.is_logged_in) {
        dispatch(removeUser());
        localStorage.removeItem("token");
      toast.info(sessionEndedMsg, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
        theme: "colored",
      });
      } else {
        FetchUserData();
      }

      return response.data;
    } catch (error) {
      // If request fails (e.g., unauthorized), assume user is not logged in
      dispatch(removeUser());
      localStorage.removeItem("token");
      toast.info(sessionEndedMsg, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
        theme: "colored",
      });
      return { is_logged_in: false };
    }
  };

  useEffect(() => {
    const initializeApp = async () => {
      fetchSocieteConfig();
      await checkUserLoggedIn();
      fetchArticles();
      fetchCategories();
      fetchCompanySettings();
      fetchCollaborators();
      fetchCollections();
      fetchCountries();
      fetchPublishers();
    };

    initializeApp();
  }, []);

  const addToFavoritehandler = async (props) => {
    const item = favorites.find((item) => item._favid === props.id);
    if (!user?.id) {
      toast.error(
        `${
          language === "eng"
            ? "Please login to add to wishlist."
            : "Veuillez vous connecter pour ajouter à votre liste de souhaits."
        }`,
        {
          position: "top-right",
          autoClose: 1500,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
          theme: "colored",
        }
      );
    } else {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_TESTING_API}/favorites`,
          {
            user_id: user.id,
            article_id: props.id,
          }
        );
        dispatch(
          addTofavorite({
            id: response.data.data.id,
            _favid: props.id,
            favtitle: props.designation,
            favauthor: props.dc_auteur,
            favimage: props.articleimage[0]?.link
              ? props.articleimage[0].link
              : bookPlaceHolder,
            favprice: props.prixpublic,
            _qte_a_terme_calcule: props._qte_a_terme_calcule,
            _code_barre: props._code_barre,
            discount: props.discount,
            favquantity: 1,
            favdescription: props.descriptif,
            weight: props._poids_net,
            price_ttc: props._prix_public_ttc,
            article_stock: props.article_stock,
          })
        );

        toast.success(
          `${
            language === "eng"
              ? "Book is added to wishlist"
              : "Le livre est ajouté à la liste de souhaits "
          }`,
          {
            position: "top-right",
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
            theme: "colored",
          }
        );
      } catch (error) {
        // console.error("Error adding to cart:", error);
        toast.error(
          `${
            language === "eng"
              ? "Failed to add item to wishlist."
              : "Échec de l'ajout d'un article à la liste de souhaits."
          }`,
          {
            position: "top-right",
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
            theme: "colored",
          }
        );
      }
    }
  };

  const deleteFavoritehandler = async (props) => {
    const item = favorites.find((item) => item._favid === props);
    // console.log(props)
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_TESTING_API}/favorites/${item.id}`
      );
      dispatch(deletefavorite(item.id));

      toast.success(
        `${
          language === "eng"
            ? "Book is removed from wishlist"
            : "Le livre est retiré de la liste de souhaits"
        }`,
        {
          position: "top-right",
          autoClose: 1500,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
          theme: "colored",
        }
      );
    } catch (error) {
      // console.error("Failed to remove book from wishlist:", error);
      toast.error(
        `${
          language === "eng"
            ? "Failed to remove book from wishlist."
            : "Le livre n'a pas été supprimé de la liste de souhaits."
        }`,
        {
          position: "top-right",
          autoClose: 1500,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
          theme: "colored",
        }
      );
    }
  };

  const seteditReturnDatahandler = (editreturnData) => {
    seteditReturnData(editreturnData);
  };

  const setReturnDatahandler = (returnData) => {
    setReturnData(returnData);
  };

  const setArticleshandler = (articles) => {
    setArticles(articles);
  };

  const setCompanySettingshandler = (articles) => {
    setCompanySettings(articles);
  };

  const contextValue = {
    selectedcurrency: selectedcurrency,
    currencyRate: currencyRate,
    isPopupCartOpen: isPopupCartOpen,
    addedBookCart: addedBookCart,
    selectedlanguage: selectedlanguage,
    reviewData: reviewData,
    bookDetails: bookDetails,
    returnData: returnData,
    editreturnData: editreturnData,
    isLoading: isLoading,
    articles: articles,
    categories: categories,
    companySettings: companySettings,
    fetchArticles: fetchArticles,
    fetchCompanySettings: fetchCompanySettings,
    fetchCategories: fetchCategories,
    setcurrencyRate: setcurrencyRate,
    setselectedcurrency: setselectedcurrency,
    setselectedlanguage: setselectedlanguage,
    setReviewData: setReviewDatahandler,
    setbookDetails: setBookDetailshandler,
    deleteFromcart: deleteFromcarthandler,
    addToCart: addToCarthandler,
    addToCartWithQty: addToCartWithQtyhandler,
    addToFavorite: addToFavoritehandler,
    deleteFavorite: deleteFavoritehandler,
    seteditReturnData: seteditReturnDatahandler,
    setReturnData: setReturnDatahandler,
    setArticles: setArticleshandler,
    setCompanySettings: setCompanySettingshandler,
    setisPopupCartOpen: setisPopupCartOpen,
    setaddedBookCart: setaddedBookCart,
    collaborators: collaborators,
    fetchCollaborators: fetchCollaborators,
    collections: collections,
    fetchCollections: fetchCollections,
    fetchfavandcartSettings: fetchfavandcartSettings,

    countries,

    societeConfig,

    checkoutError,
    setCheckoutError,

    isCompareEnabled,

    publishers,
  };

  return (
    <AuthContext.Provider value={contextValue}>
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
